import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useQueryFindAllEntities } from '../../../../../shared/queries/entityInformationDiagnostics';
import { taxYearSelector } from '../../../../../shared/store/selectors';
import AgGrid from '../../../../../shared/displayComponents/agGrid/agGrid.component';
import { rowSelectionMultiRowWithColumnCheckboxes } from '../../../../../shared/displayComponents/agGrid/constants';
import type { TabProps, Entity } from '../../types';

import ColumnDefinitions from './allEntities.columnDefinitions';

const AllEntities = ({ onSelectionChanged, isLoading }: TabProps) => {
  const columnDefinitions = ColumnDefinitions;

  const taxYear = useSelector(taxYearSelector);

  const { data: entities, isFetching: isFetchingEntities } = useQueryFindAllEntities({
    taxYear,
    enabled: Boolean(taxYear),
  });

  const getRowId = useMemo(() => ({ data }: { data: Entity }) => data?.orgId, []);

  return (
    <>
      <AgGrid
        rowData={entities}
        columnDefs={columnDefinitions}
        withSearchBar
        autoMaxWidth
        isGridLoading={isFetchingEntities || isLoading}
        rowSelection={rowSelectionMultiRowWithColumnCheckboxes}
        onSelectionChanged={onSelectionChanged}
        getRowId={getRowId}
      />
    </>
  );
};

export default AllEntities;
